



















































































import {
  Component, Prop, PropSync, Vue,
} from 'vue-property-decorator';
import SvgIcon from '@/components/SvgIcon.vue';
import DpInput from '@/components/atoms/DpInput/index.vue';
import DpButton from '@/components/atoms/DpButton/index.vue';
import DpDialog from '@/components/molecules/DpDialog/index.vue';
import DpIconButton from '@/components/atoms/DpIconButton/index.vue';

@Component({
  name: 'MarketRegionSubscribedSuccessDialog',
  components: {
    SvgIcon,
    DpInput,
    DpButton,
    DpDialog,
    DpIconButton,
  },
})
export default class MarketRegionSubscribedSuccessDialog extends Vue {
  @Prop() protected email!: string;

  @Prop() protected marketTitle!: string;

  @PropSync('show', { type: Boolean }) syncedShow!: boolean;

  protected onClose() {
    this.syncedShow = false;
  }
}
